export enum ExternalLoginServiceEnum
{
    Google = 1,
    Facebook = 2,
}